module.exports = __webpack_public_path__ + "static/img/abc.0e575e6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/abc.gif
// module id = LuI/
// module chunks = 1